module.exports = __webpack_public_path__ + "fonts/OpenSans-Medium.12f31453.ttf";